import { isSSR } from "./isSSR";

const APP_ID = "k8qa127s";
const API_BASE = "https://api-iam.intercom.io";

export function loadIntercomChart(lang) {
  if (isSSR()) return;
  
  const user = JSON.parse(localStorage.getItem("client_profile"));
  
  const hasUser = !!(user && user.id);

  const settings = {
    app_id: APP_ID,
    api_base: API_BASE,
    language_override: lang
  };
  
  if (hasUser) {
    settings.user_id = String(user.id);
    
    if (user.name) settings.name = user.name;
    if (user.email) settings.email = user.email;
  }
  
  window.intercomSettings = settings;
  
  function bootOrUpdate() {
    if (typeof window.Intercom !== "function") return;
    
    if (window.__intercomBooted) {
      window.Intercom("update", window.intercomSettings);
    } else {
      window.Intercom("boot", window.intercomSettings);
      window.__intercomBooted = true;
    }
  }
  
  if (typeof window.Intercom === "function") {
    bootOrUpdate();
    return;
  }
  
  var i = function () {
    i.c(arguments);
  };
  i.q = [];
  i.c = function (args) {
    i.q.push(args);
  };
  window.Intercom = i;
  
  let s = document.querySelector('script[data-intercom-script="true"]');

  if (!s) {
    s = document.createElement("script");
    s.type = "text/javascript";
    s.async = true;
    s.src = "https://widget.intercom.io/widget/" + APP_ID;
    s.setAttribute("data-intercom-script", "true");
    s.onload = bootOrUpdate;
    
    const x = document.getElementsByTagName("script")[0];
    
    if (x && x.parentNode) x.parentNode.insertBefore(s, x);
  } else {
    s.addEventListener("load", bootOrUpdate, { once: true });
  }
}
